"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ListViewComponent_1;
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const store_1 = require("@ngrx/store");
const idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
const idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
const idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
const idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
const idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
const idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
const skynet_store_currencies_api_1 = require("@synisys/skynet-store-currencies-api");
const Observable_1 = require("rxjs/Observable");
const from_1 = require("rxjs/observable/from");
const operators_1 = require("rxjs/operators");
const export_data_proccessing_service_1 = require("../../controls/export/export-data-proccessing-service");
const multilingual_type_helper_1 = require("../../shared/multilingual-type-helper");
const page_filter_service_1 = require("../page-filter/service/page-filter.service");
const reporting_controls_common_logic_1 = require("../shared/reporting-controls-common-logic");
const list_builder_component_1 = require("./list-builder.component");
const list_report_field_1 = require("./list-enums/list-report-field");
const list_model_1 = require("./shared/list.model");
/**
 * Created by aghavni.grigoryan on 6/20/2017.
 */
let ListViewComponent = ListViewComponent_1 = class ListViewComponent extends reporting_controls_common_logic_1.ReportingControlsCommonLogic {
    constructor(elementRef, _currentLanguageProvider, _categoryPathService, _reportingService, _pathService, _reportExportService, _messageService, _formResolverService, _httpPathService, store, localeService, kbService, staticResourceUrlProvider, _activatedRoute, communicationService, pageFilterService) {
        super(_activatedRoute, communicationService, pageFilterService);
        this.elementRef = elementRef;
        this._currentLanguageProvider = _currentLanguageProvider;
        this._categoryPathService = _categoryPathService;
        this._reportingService = _reportingService;
        this._pathService = _pathService;
        this._reportExportService = _reportExportService;
        this._messageService = _messageService;
        this._formResolverService = _formResolverService;
        this._httpPathService = _httpPathService;
        this.store = store;
        this.localeService = localeService;
        this.kbService = kbService;
        this.staticResourceUrlProvider = staticResourceUrlProvider;
        this.MeasurePathType = idm_dataset_service_client_js_1.MeasurePathType;
        this.COLUMN_MIN_WIDTH = 120;
        /**
         * List report id
         */
        this.id = "list";
        /**
         * Indicates if report is valid and has data to render
         */
        this.hasData = false;
        /**
         * Indicates if report is valid
         */
        this.isValid = false;
        this.isConfigured = false;
        this.isOrientable = true;
        this.reportLayerId = 0;
        /**
         * Selected page on list
         * @type {number}
         */
        this.currentPage = 1;
        /**
         * Object which describes sorting type and object
         * @type {{}}
         */
        this.sortData = {};
        /**
         * Selected page size
         * @type {number}
         */
        this.pageSize = 10;
        // Total row marker
        this.totalMarker = "Total";
        this.LIST_PAGING_MESSAGE_KEY = "reporting.controls.list-view.paging.message";
        this.LIST_BOOLEAN_VALUE_TRUE_KEY = "boolean_measure_value_true";
        this.LIST_BOOLEAN_VALUE_FALSE_KEY = "boolean_measure_value_false";
        this.HUGE_REPORT_ABOVE_TWO_MILLIONS_MESSAGE = 'reporting_designer_huge_report_above_two_millions';
        this.HUGE_REPORT_ABOVE_TEN_THOUSANDS_MESSAGE = 'reporting_designer_big_report_above_ten_thousands';
        // Property stores in report used clickable categories with their forms
        this.clickableCategoryForms = new Map();
        // Property stores by report level loaded instance id, url
        this.instanceIdUrlMap = new Map();
        this.measureTypeMap = new Map();
        this.exportPageOrientation = idm_report_export_service_client_js_1.ExportPageOrientation.PORTRAIT;
        this.csvDelimiter = idm_report_export_service_client_js_1.CSVDelimiter.COMMA;
        this.categoriesWithIcon = new Map();
        this.categoryIconIdURLMap = new Map();
        this.defaultIconURL = null;
        this.isRcListTitleLongerThenSection = false;
        this.listData = [];
        this.loadCategoryIconPath();
    }
    /**
     * This property stores control title.
     */
    set title(title) {
        this.reportTitle = multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(title);
    }
    ngOnChanges(changes) {
        if (!changes['state']) {
            !this.listModel && (this.listModel = new list_model_1.ListModel());
            changes['listModel'] && (this.listReportModel = this.listModel.getListReportModel());
            changes['listModel'] && (this.listReportDepth = this.listReportModel.rowCategories.length);
            (changes['dataSetId'] || changes['listModel']) && this.redrawWithSubscribeToPageFilterChange();
        }
        if (changes['state'] || changes['entity'] || changes['filters']) {
            !this.listModel && (this.listModel = new list_model_1.ListModel());
            this.listModel.fromJsonString(this.state);
            this.listReportModel = this.listModel.getListReportModel();
            this.listReportDepth = this.listReportModel.rowCategories.length;
            this.validationMessage = null;
            // redraw is called when page filters will be ready
            this.redrawWithSubscribeToPageFilterChange();
        }
    }
    ngOnInit() {
        (this.id === '' || this.id === undefined) && (this.id = "list");
    }
    ngAfterViewInit() {
        if (this.rcListToolbarSection && this.rcListToolbarTitle) {
            let titleMarginRight = 16;
            this.isRcListTitleLongerThenSection = this.rcListToolbarSection.nativeElement.offsetWidth === this.rcListToolbarTitle.nativeElement.offsetWidth + titleMarginRight;
        }
    }
    onPageChange(event) {
        const detail = event.detail;
        if (this.pageSize !== detail.pageSize || this.currentPage !== detail.currentPage) {
            this.pageSize = detail.pageSize;
            this.currentPage = detail.currentPage;
            this.loadData(this.reportLayerId, null, (this.currentPage - 1) * this.pageSize, this.pageSize)
                .then((result) => {
                this.listData = result ? result.listReportData : [];
            });
        }
    }
    onExpand(event) {
        const detail = event.detail;
        if (detail.identifier) {
            const idLevelPair = detail.identifier.split('-');
            const clickedItemIndex = idLevelPair && Number(idLevelPair[2]);
            if (idLevelPair && !isNaN(clickedItemIndex)) {
                const parent = this.listData[clickedItemIndex];
                if (!parent.dirty) {
                    parent.dirty = true;
                    parent.showExpandLoading = true;
                    let parentIds = [];
                    if (parent.level === 0) {
                        parentIds.push(parent.id);
                    }
                    else {
                        parentIds = parentIds.concat(parent.parentIds);
                        parentIds.push(parent.id);
                    }
                    this.loadData(parent.level + 1, parentIds, 0, ListViewComponent_1.EXPAND_PAGING_SIZE)
                        .then((result) => {
                        parent.showExpandLoading = false;
                        if (result && result.listReportData) {
                            parent.childrenCount = result.rowsCount;
                            // find index of clicked item again, because index could be changed as a result of other expand or load more event
                            const expandedItemIndex = this.listData.findIndex(row => row === parent);
                            const copyOfData = this.listData.slice();
                            copyOfData.splice(expandedItemIndex + 1, 0, ...result.listReportData);
                            this.listData = copyOfData;
                        }
                    });
                }
            }
        }
    }
    onLoadMore(event) {
        const detail = event.detail;
        if (detail.identifier) {
            const idLevelPair = detail.identifier.split('-');
            const clickedItemIndex = idLevelPair && Number(idLevelPair[2]);
            if (idLevelPair && !isNaN(clickedItemIndex)) {
                const parent = this.listData[clickedItemIndex];
                // find index of the first element which level is equal or smaller than clicked item level
                let offset = this.listData.findIndex((row, index) => row.level <= parent.level && index > clickedItemIndex + 1);
                offset < 0 && (offset = this.listData.length);
                // item with (offset - 1) index is the last child of the clicked item, we should place loading skeleton after the last child
                this.listData[offset - 1].showLoadMoreLoading = true;
                this.listData[offset - 1].loadMoreLevel = parent.level + 1;
                let parentIds = [];
                if (parent.level === 0) {
                    parentIds.push(parent.id);
                }
                else {
                    parentIds = parentIds.concat(parent.parentIds);
                    parentIds.push(parent.id);
                }
                this.loadData(parent.level + 1, parentIds, detail.loadedCount, ListViewComponent_1.LOAD_MORE_PAGING_SIZE)
                    .then((result) => {
                    // find index of clicked item again, because index could be changed as a result of other expand or load more event
                    const expandedItemIndex = this.listData.findIndex(row => row === parent);
                    const copyOfData = this.listData.slice();
                    // item with offset index is the item after the last child of our clicked item, we should place new items after the last child of the clicked item
                    let offset = copyOfData.findIndex((row, index) => row.level <= parent.level && index > expandedItemIndex + 1);
                    offset < 0 && (offset = copyOfData.length);
                    this.listData[offset - 1].showLoadMoreLoading = false;
                    this.listData[offset - 1].loadMoreLevel = null;
                    if (result && result.listReportData) {
                        copyOfData.splice(offset, 0, ...result.listReportData);
                        this.listData = copyOfData;
                    }
                });
            }
        }
    }
    redraw() {
        this.redrawList();
    }
    resetState() {
        this.listData = [];
        this.rowsCount = 0;
    }
    /**
     * Method is called any time, when report model, or dataSet, or language were changed
     * and redraw list
     */
    redrawList() {
        this.isConfigured = this.listReportModel && this.listReportModel.validateReport();
        if (this.isConfigured) {
            this.isValid = true;
            this.hasData = false;
            if (this.isDataLoaded) {
                this.columns = this.createListHeaders();
                this.resetState();
                this.loadData(this.reportLayerId, null, (this.currentPage - 1) * this.pageSize, this.pageSize)
                    .then((result) => {
                    this.rowsCount = result ? result.rowsCount : 0;
                    this.listData = result ? result.listReportData : [];
                });
            }
            else {
                const categoryMeasurePaths = Observable_1.Observable.from(this._pathService.getPaths(this.dataSetId));
                const categoryPathForms = Observable_1.Observable.from(this._httpPathService.getPathHolderForms(this.dataSetId));
                const metaCategories = this.kbService.getAllMetaCategories('reporting');
                Observable_1.Observable.zip(categoryMeasurePaths, categoryPathForms, metaCategories)
                    .pipe(operators_1.takeUntil(this.destroy$))
                    .subscribe((data) => {
                    this.categoryMeasurePaths = data[0];
                    this.categoryPathForms = data[1];
                    const map = new Map();
                    data[2] && data[2].forEach(metaCategory => {
                        map.set(metaCategory.getSystemName(), metaCategory);
                    });
                    this.metaCategories = map;
                    this.loadLanguageAndMessages();
                });
            }
        }
        else {
            this.isValid = false;
            this.hasData = false;
        }
    }
    /**
     * These method subscribes to language and message changes
     */
    loadLanguageAndMessages() {
        const currentLanguage = this._currentLanguageProvider.getCurrentLanguage();
        const rootPathObservable = Observable_1.Observable.from(this._categoryPathService.getRootCategoryPath(this.dataSetId));
        const currencies = skynet_store_currencies_api_1.currencyStoreManager.selectAll(this.store).pipe(operators_1.filter((currencies) => !currencies.isEmpty()));
        const messageKeys = [
            this.LIST_PAGING_MESSAGE_KEY,
            this.LIST_BOOLEAN_VALUE_TRUE_KEY,
            this.LIST_BOOLEAN_VALUE_FALSE_KEY,
            ListViewComponent_1.UNTITLED_MESSAGE_KEY
        ];
        currentLanguage
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.switchMap((currentLanguage) => {
            this.currentLanguageId = currentLanguage.getId();
            return Observable_1.Observable.zip(from_1.from(this.localeService.getLocaleInfo(this.currentLanguageId)), from_1.from(this._messageService.getMessages(this.currentLanguageId, messageKeys)), rootPathObservable, currencies, from_1.from(this.processCategoryIcons()), skynet_store_currencies_api_1.getDefaultCurrency(this.store));
        }))
            .subscribe(([localeInfo, messages, rootCategory, currencies, categoryIconIdURLMap, currencyModel]) => {
            this.isDataLoaded = true;
            this.localeInfo = localeInfo;
            this.LIST_PAGING_MESSAGE = messages.get(messageKeys[0]);
            this.LIST_BOOLEAN_VALUE_TRUE = messages.get(messageKeys[1]);
            this.LIST_BOOLEAN_VALUE_FALSE = messages.get(messageKeys[2]);
            this.untitledMessage = messages.get(messageKeys[3]);
            this.currencies = Array.from(currencies.toList());
            this.categoryIconIdURLMap = categoryIconIdURLMap;
            this.defaultCurrencyId = currencyModel.id;
            this.rootCategory = rootCategory;
            // initializes widget title the first time
            this.widgetTitle = this.getWidgetTitle();
            this.processCategoryForms();
            this.columns = this.createListHeaders();
            this.resetState();
            this.loadData(this.reportLayerId, null, (this.currentPage - 1) * this.pageSize, this.pageSize)
                .then((result) => {
                this.rowsCount = result ? result.rowsCount : 0;
                this.listData = result ? result.listReportData : [];
            });
        });
    }
    loadData(reportLayer, reportLayerFilters, offset, pageSize) {
        this.reportingError = false;
        return this.getListDataByLevel(reportLayer, reportLayerFilters, offset, pageSize)
            .then((reportData) => {
            let data = this.processListReportData(reportData, reportLayer);
            let listReportData = data.listData;
            if (listReportData.length === 0) {
                if (reportLayer === 0) {
                    this.validationMessage = reporting_controls_common_logic_1.ReportingControlsCommonLogic.NO_DATA_MESSAGE;
                    this.isValid = false;
                }
                return;
            }
            else {
                const categoryPathId = this.listReportModel.rowCategories[reportLayer];
                const category = this.categoriesWithIcon.get(categoryPathId);
                // This is done to save filters from root for report (In custom parentIds column)
                listReportData.forEach((element) => {
                    element.parentIds = reportLayerFilters;
                    // add icon paths
                    if (category && element.id !== null && element.id !== this.totalMarker && this.defaultIconURL) {
                        let categoryIconUrl = this.categoryIconIdURLMap.get(`${category}/${element.id}`);
                        element.data[0].iconPath = categoryIconUrl || this.defaultIconURL;
                    }
                });
                // These was done to load category element url for loaded data, if used category is clickable.
                if (this.clickableCategoryForms.get(this.listReportModel.rowCategories[reportLayer]) !== undefined) {
                    let clickableElementsIds = [];
                    listReportData.forEach((element) => {
                        // Add all elements except "total" and "unspecified"
                        element.id !== null && element.id !== this.totalMarker && clickableElementsIds.push(element.id) && this.instanceIdUrlMap.set(element.Id, "");
                    });
                    // Only if there is data load urls and after load and process draw list
                    if (clickableElementsIds.length) {
                        return this.getClickableCategoryUrls(clickableElementsIds, reportLayer)
                            .then((results) => {
                            let index = 0;
                            listReportData.forEach((element) => {
                                // set url of elements except "total" and "unspecified"
                                if (element.id !== null && element.id !== this.totalMarker) {
                                    // encode url for escaping spaces
                                    element.data[0].url = results[index] ? encodeURI(results[index]) : '';
                                    index++;
                                }
                            });
                            this.hasData = true;
                            this.sendWidgetExportData();
                            return { listReportData, rowsCount: data.rowsCount };
                        });
                    }
                }
                this.hasData = true;
                this.sendWidgetExportData();
                return { listReportData, rowsCount: data.rowsCount };
            }
        }, (errorResponse) => {
            if (errorResponse.status === 422) {
                this.validationMessage = this.HUGE_REPORT_ABOVE_TWO_MILLIONS_MESSAGE;
                this.isValid = false;
            }
            else if (errorResponse.status === 413) {
                this.validationMessage = this.HUGE_REPORT_ABOVE_TEN_THOUSANDS_MESSAGE;
                this.isValid = false;
            }
            else {
                this.reportingErrorHandler();
            }
        });
    }
    refreshView(filtersMap) {
        if (this.dataSetId) {
            const pageFilter = filtersMap.get(this.dataSetId);
            if (this.pageFilterTreeDto != pageFilter) {
                this.pageFilterTreeDto = pageFilter;
                this.redrawList();
            }
        }
    }
    /**
     * Based on selected report depth method create report, filter, paging, reportOptions and load data
     * @param depth
     * @param reportLayerFilters
     * @param offset
     * @param pageSize
     * @returns {Promise<string>}
     */
    getListDataByLevel(depth, reportLayerFilters, offset, pageSize) {
        let listReportByDepth = this.buildReport(depth);
        let listReportFilterByDepth = this.buildReportFilter(reportLayerFilters, depth);
        let reportOptions = this.buildReportOptions();
        let pagingCriteria = idm_reporting_service_client_js_1.PagingCriteria.of(offset, pageSize);
        return this._reportingService.executeReport(listReportByDepth, listReportFilterByDepth, this.currentLanguageId, this.dataSetId, reportOptions, pagingCriteria);
    }
    /**
     * Based on selected depth method generate report, with selected sorting option or default
     * @param reportDepth
     * @returns {ReportDto}
     */
    buildReport(reportDepth) {
        let measurePaths = this.categoryMeasurePaths.measurePaths;
        let categoryPaths = this.categoryMeasurePaths.categoryPaths;
        let rowCategories = this.listReportModel.rowCategories;
        let columnCategories = this.listReportModel.columnCategories;
        let columnMeasures = this.listReportModel.columnMeasures;
        let reportBuilder = new idm_reporting_service_client_js_1.ReportDtoBuilder();
        // Build report column measure with sorting order if it set on column measures
        let isSortedByColumnCategory = (this.sortData["orderType"] !== undefined && this.sortData["sortFieldType"] === list_report_field_1.ListReportFieldType.COLUMN_CATEGORY_FIELD);
        columnCategories.forEach((category) => {
            let columnCategoryBuilder = reportBuilder.addColumnCategory(category);
            isSortedByColumnCategory && category == this.sortData["sortItemId"] && columnCategoryBuilder.setOrderType(this.sortData["orderType"]);
            // If selected category type not number, hide it from total row
            let columnCategory = categoryPaths.get(category);
            !(columnCategory.categoryType === idm_dataset_service_client_js_1.CategoryType.CURRENCY) && columnCategoryBuilder.setShowOnRowsTotal(false);
        });
        // Build report column categories with sorting order if it set on column category
        let isSortedByColumnMeasure = (this.sortData["orderType"] !== undefined && this.sortData["sortFieldType"] === list_report_field_1.ListReportFieldType.COLUMN_MEASURE_FILED);
        columnMeasures.forEach((measure) => {
            let columnMeasureBuilder = reportBuilder.addColumnMeasure(measure.id);
            isSortedByColumnMeasure && measure.id == this.sortData["sortItemId"] && measure.currencyId == this.sortData["sortItemCurrencyId"] && columnMeasureBuilder.setOrderType(this.sortData["orderType"]);
            if (measure.currencyId) {
                columnMeasureBuilder.setCurrencyId(measure.currencyId);
            }
            else {
                columnMeasureBuilder.setCurrencyId(this.defaultCurrencyId);
            }
            // If selected measure type not number, hide it from total row
            let measurePath = measurePaths.get(measure.id);
            this.measureTypeMap.set(measurePath.id, measurePath.measurePathType);
            !(measurePath.measurePathType === idm_dataset_service_client_js_1.MeasurePathType.MONEY || measurePath.measurePathType === idm_dataset_service_client_js_1.MeasurePathType.NUMBER) && columnMeasureBuilder.setShowOnRowsTotal(false);
        });
        // Build report row categories with sorting order if it set on rows
        let isSortedByRowCategory = (this.sortData["orderType"] !== undefined && this.sortData["sortFieldType"] === list_report_field_1.ListReportFieldType.ROW_CATEGORY_FIELD);
        let rowCategoryBuilder = reportBuilder.addRowCategory(rowCategories[reportDepth]);
        isSortedByRowCategory && rowCategoryBuilder.setOrderType(this.sortData["orderType"]);
        // TODO: in the second version implement total logic
        // If this is the list reports first layer set total
        reportDepth === 0 && rowCategoryBuilder.setTotalType(idm_reporting_service_client_js_1.TotalType.AFTER);
        return reportBuilder.build();
    }
    /**
     * For selected report level, method create and return filter tree
     * @param filterData
     * @param reportLayer
     * @returns {FilterTreeDto}
     */
    buildReportFilter(filterData, reportLayer) {
        // Create report filter tree based on selected report depth
        let filterDtoBuilder = idm_reporting_service_client_js_1.FilterDtoBuilder.createAndFilterBuilder();
        let rowCategories = this.listReportModel.rowCategories;
        let rowCategoryIndex = 0;
        while (rowCategoryIndex < reportLayer) {
            filterDtoBuilder.filterByCategory(rowCategories[rowCategoryIndex]).in(new Set([filterData[rowCategoryIndex++]]));
        }
        let filterTreeByDepth = filterDtoBuilder.build();
        // If there is applied filter, merge it with generated filter tree
        let savedFilterTree = this.listModel.getFilter();
        let listReportLayerFilter = savedFilterTree;
        if (filterTreeByDepth.rootOperator && savedFilterTree && savedFilterTree.rootOperator) {
            listReportLayerFilter = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(filterTreeByDepth, savedFilterTree);
        }
        else if (filterTreeByDepth.rootOperator) {
            listReportLayerFilter = filterTreeByDepth;
        }
        let entityId = this.entity && this.entity.getInstanceId();
        this.pageFilterTreeDto && (listReportLayerFilter = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(listReportLayerFilter, this.pageFilterTreeDto));
        (this.filters || entityId) && (listReportLayerFilter = this.updateFilters(this.filters, listReportLayerFilter, this.category, entityId, this.rootCategory));
        return listReportLayerFilter;
    }
    createListHeaders() {
        let columns = [];
        let rowCategories = this.listReportModel.rowCategories;
        let rowCategoriesTitleParts = [];
        let categoryPaths = this.categoryMeasurePaths.categoryPaths;
        let measurePaths = this.categoryMeasurePaths.measurePaths;
        // Building row category column. As title we use merged names of all row categories.
        rowCategories.forEach((el) => {
            rowCategoriesTitleParts.push(categoryPaths.get(el).name.get(this.currentLanguageId));
        });
        columns.push({
            title: rowCategoriesTitleParts.join("/")
        });
        const measureHeaders = this.listReportModel.columnMeasures.map((measureEl) => {
            let dataProperties = measurePaths.get(measureEl.id);
            return {
                id: measureEl.id,
                title: dataProperties.name.get(this.currentLanguageId),
                type: dataProperties.measurePathType
            };
        });
        // Building column measure fields
        columns = columns.concat(measureHeaders);
        return columns;
    }
    /**
     * Method filter and stores categories with forms, that are clickable.
     */
    processCategoryForms() {
        let pathForms = this.categoryPathForms.pathForms;
        let reportColumnCategories = this.listReportModel.columnCategories;
        let reportRowCategories = this.listReportModel.rowCategories;
        let categoriesInReport = Array.prototype.concat.apply([], [reportColumnCategories, reportRowCategories]);
        categoriesInReport.forEach(categoryPathId => {
            let categoryPaths = pathForms.get(categoryPathId);
            categoryPaths !== undefined && this.clickableCategoryForms.set(categoryPathId, categoryPaths[idm_dataset_service_client_js_1.FormType[idm_dataset_service_client_js_1.FormType.VIEW]][0]);
        });
    }
    processCategoryIcons() {
        let reportColumnCategories = this.listReportModel.columnCategories;
        let reportRowCategories = this.listReportModel.rowCategories;
        let categoriesInReport = Array.prototype.concat.apply([], [reportColumnCategories, reportRowCategories]);
        let categoriesWithIcons = [];
        categoriesInReport.forEach(categoryPathId => {
            let categorySystemName = this.categoryMeasurePaths.categoryPaths.get(categoryPathId).metaCategoryId.systemName;
            const metaCategory = this.metaCategories.get(categorySystemName);
            if (metaCategory && metaCategory.getHasIcon()) {
                this.categoriesWithIcon.set(categoryPathId, metaCategory.getSystemName());
                categoriesWithIcons.push(categorySystemName);
            }
        });
        return categoriesWithIcons.length !== 0 ? this.getCategoryIconMap(categoriesWithIcons) : Promise.resolve(new Map());
    }
    processListReportData(listData, level) {
        let processedData = [];
        let rowsCount = 0;
        if (listData.tables[0] !== undefined) {
            let values = listData.tables[0].columnGrouping.values;
            let rowsData = listData.tables[0].rowGrouping;
            let columnIds = this.listReportModel.columnMeasures.map(item => item.id);
            rowsData.forEach((row, rowIndex) => {
                let currentRowData = rowsData[rowIndex].rowCategories[0];
                let currentRowValues = rowsData[rowIndex].values.slice();
                let rowData = {
                    id: (currentRowData.id === null ? currentRowData.isTotal == true ? this.totalMarker : null : currentRowData.id),
                    level: level,
                    data: [
                        { value: row.rowCategories[0].name }
                    ]
                };
                values.forEach((value, index) => {
                    let id = columnIds[index];
                    if (this.measureTypeMap.get(id) === idm_dataset_service_client_js_1.MeasurePathType.BOOLEAN) {
                        currentRowValues[index] = currentRowValues[index] ? this.LIST_BOOLEAN_VALUE_TRUE : this.LIST_BOOLEAN_VALUE_FALSE;
                    }
                    else {
                        let measure = this.listReportModel.columnMeasures[index - this.listReportModel.columnCategories.length];
                        let symbol = measure.currencyId ? this.currencies.find((currency) => currency.id === measure.currencyId).symbol : '';
                        currentRowValues[index] = this.formatValue(id, currentRowValues[index], symbol);
                    }
                    rowData.data.push({ value: currentRowValues[index] });
                });
                Object.keys(rowData).length && processedData.push(rowData);
            });
            rowsCount = listData.rowsCount;
        }
        return { listData: processedData, rowsCount: rowsCount };
    }
    /**
     * Combine clickable category instance view url getter observables and return.
     * @param itemsToGetUrl
     * @param reportLevel
     * @returns {any}
     */
    getClickableCategoryUrls(itemsToGetUrl, reportLevel) {
        let categoryPathId = this.listReportModel.rowCategories[reportLevel];
        let categorySystemName = this.categoryMeasurePaths.categoryPaths.get(categoryPathId).metaCategoryId.systemName;
        let elementUrlsGetterArray = [];
        itemsToGetUrl.forEach((instanceId) => {
            let formProperties = this.clickableCategoryForms.get(categoryPathId);
            const formName = formProperties ? formProperties.split(':')[0] : '';
            const formId = formProperties ? Number(formProperties.split(':')[1]) : 0;
            let getUrlByInstance = this._formResolverService.getUrlForViewDeForm(categorySystemName, formName, instanceId, formId);
            elementUrlsGetterArray.push(getUrlByInstance);
        });
        return Promise.all(elementUrlsGetterArray);
    }
    formatValue(id, value, symbol) {
        if (!value) {
            return value;
        }
        let measureType = this.measureTypeMap.get(id);
        const numberValue = +value;
        switch (measureType) {
            case idm_dataset_service_client_js_1.MeasurePathType.DATE: {
                if (isNaN(numberValue)) {
                    return value;
                }
                return this.localeService.formatDateByLocale(numberValue, this.localeInfo);
            }
            case idm_dataset_service_client_js_1.MeasurePathType.DATETIME: {
                if (isNaN(numberValue)) {
                    return value;
                }
                return this.localeService.formatDateTimeByLocale(numberValue, this.localeInfo);
            }
            case idm_dataset_service_client_js_1.MeasurePathType.NUMBER: {
                return this.localeService.formatNumberByLocale(numberValue, this.localeInfo);
            }
            case idm_dataset_service_client_js_1.MeasurePathType.MONEY: {
                return symbol + this.localeService.formatNumberByLocale(numberValue, this.localeInfo);
            }
            default: {
                return value;
            }
        }
    }
    loadCategoryIconPath() {
        this.staticResourceUrlProvider.getStaticResourcesUrl()
            .then((path) => {
            this.defaultIconURL = `${path.url}${ListViewComponent_1.CATEGORIES_ICONS_PATH}default`;
        })
            .catch((error) => {
            console.warn('Category icon path is missing ! Please define category icon path.', error);
        });
    }
    getCategoryIconMap(categories) {
        let categoryIconPromises = categories.map(category => this.staticResourceUrlProvider.getResources(`${ListViewComponent_1.CATEGORIES_ICONS_PATH}${category}`));
        return Promise.all(categoryIconPromises)
            .then((resourceList) => {
            let resourceIdURLMap = new Map();
            resourceList.forEach((resources) => {
                resources.forEach((resource) => {
                    let id = resource.split(`${ListViewComponent_1.CATEGORIES_ICONS_PATH}`)[1];
                    resourceIdURLMap.set(id, resource);
                });
            });
            return resourceIdURLMap;
        });
    }
    addExportPageOrientation(pageOrientation) {
        this.exportPageOrientation = pageOrientation;
    }
    addCsvDelimiter(csvDelimiter) {
        this.csvDelimiter = csvDelimiter;
    }
    /**
     * Method getting selected export type and called export service for selected report export.
     * @param exportType
     */
    buildExportReport(exportType) {
        let { exportReport, exportReportFilter, reportOptions } = this.getExportData(this.exportPageOrientation, this.csvDelimiter);
        this._reportExportService.exportReport(exportReport, exportType, exportReportFilter, this.currentLanguageId, reportOptions, null, this.dataSetId);
    }
    getExportDto(type, orientation) {
        const exportType = idm_report_export_service_client_js_1.ExportType[idm_dynamic_controls_metadata_1.ExportType[type]];
        const exportOrientation = idm_report_export_service_client_js_1.ExportPageOrientation[idm_dynamic_controls_metadata_1.ExportOrientation[orientation]];
        let { exportReport, exportReportFilter, reportOptions } = this.getExportData(exportOrientation);
        const params = new Map()
            .set('report', JSON.stringify(exportReport.reportDto))
            .set('exportReportStyle', JSON.stringify(exportReport.exportReportStylesDto.toJsonObject()))
            .set('filters', exportReportFilter.toJson())
            .set('languageId', this.currentLanguageId.toString())
            .set('reportOptions', reportOptions.toJson())
            .set('renderType', idm_report_export_service_client_js_1.ExportType[exportType])
            .set('dataSetId', this.dataSetId.toString())
            .set('pagingCriteria', idm_reporting_service_client_js_1.PagingCriteria.all().toJson());
        return {
            url: null,
            serviceKey: export_data_proccessing_service_1.ExportDataProcessingService.REPORT_EXPORT_SERVICE_URL_KEY,
            serviceContext: export_data_proccessing_service_1.ExportDataProcessingService.REPORT_EXPORT_SERVICE_ENDPOINT,
            method: export_data_proccessing_service_1.ExportDataProcessingService.EXPORT_SERVICE_METHOD,
            cardTitle: this.widgetTitle,
            headers: new Map(),
            contentType: export_data_proccessing_service_1.ExportDataProcessingService.REPORT_EXPORT_SERVICE_CONTENT_TYPE,
            body: null,
            params: params
        };
    }
    isNumberColumn(column) {
        return column.type === idm_dataset_service_client_js_1.MeasurePathType.NUMBER || column.type === idm_dataset_service_client_js_1.MeasurePathType.MONEY;
    }
    static convertFontStyleToBackendFormat(input) {
        if (input) {
            let output = new idm_report_export_service_client_js_1.TextStyleDtoBuilder();
            let fontNameKey = (input.fontName || '').toUpperCase().replace(/\s/g, '_');
            let alignMap = {
                left: idm_report_export_service_client_js_1.Align.LEFT,
                center: idm_report_export_service_client_js_1.Align.CENTER,
                right: idm_report_export_service_client_js_1.Align.RIGHT
            };
            output.fontName(idm_report_export_service_client_js_1.FontName[fontNameKey] || idm_report_export_service_client_js_1.FontName.ARIAL);
            output.fontSize(input.fontSize);
            output.isBold(input.isBold);
            output.isItalic(input.isItalic);
            output.isUnderline(input.isUnderline);
            output.align(alignMap[input.align] || idm_report_export_service_client_js_1.Align.LEFT);
            output.color(input.color);
            output.backgroundColor(input.backgroundColor);
            return output.build();
        }
        return null;
    }
    /**
     * Based on selected depth method generate exported report, with selected sorting option or default
     * @returns {ReportDto}
     */
    buildExportedReport() {
        let measurePaths = this.categoryMeasurePaths && this.categoryMeasurePaths.measurePaths;
        let categoryPaths = this.categoryMeasurePaths && this.categoryMeasurePaths.categoryPaths;
        let exportSettings = this.listModel.listOptions.listExportSettings;
        let rowCategories = this.listReportModel.rowCategories;
        let columnCategories = this.listReportModel.columnCategories;
        let columnMeasures = this.listReportModel.columnMeasures;
        let exportReportBuilder = new idm_report_export_service_client_js_1.ExportReportDtoBuilder();
        // Build report column measure with sorting order if it set on column measures
        let isSortedByColumnCategory = (this.sortData["orderType"] !== undefined && this.sortData["sortFieldType"] === list_report_field_1.ListReportFieldType.COLUMN_CATEGORY_FIELD);
        columnCategories.forEach((category) => {
            let columnCategoryBuilder = exportReportBuilder.addColumnCategory(category);
            isSortedByColumnCategory && category == this.sortData["sortItemId"] && columnCategoryBuilder.setOrderType(this.sortData["orderType"]);
            // If selected category type not number, hide it from total row
            if (categoryPaths) {
                let columnCategory = categoryPaths.get(category);
                !(columnCategory.categoryType === idm_dataset_service_client_js_1.CategoryType.CURRENCY) && columnCategoryBuilder.setShowOnRowsTotal(false);
            }
        });
        // Build report column categories with sorting order if it set on column category
        let isSortedByColumnMeasure = (this.sortData["orderType"] !== undefined && this.sortData["sortFieldType"] === list_report_field_1.ListReportFieldType.COLUMN_MEASURE_FILED);
        columnMeasures.forEach((measure) => {
            let columnMeasureBuilder = exportReportBuilder.addColumnMeasure(measure.id);
            isSortedByColumnMeasure && measure.id == this.sortData["sortItemId"] && measure.currencyId == this.sortData["sortItemCurrencyId"] && columnMeasureBuilder.setOrderType(this.sortData["orderType"]);
            if (measure.currencyId) {
                columnMeasureBuilder.setCurrencyId(measure.currencyId);
            }
            // If selected measure type not number, hide it from total row
            if (measurePaths) {
                let measurePath = measurePaths.get(measure.id);
                !(measurePath.measurePathType === idm_dataset_service_client_js_1.MeasurePathType.MONEY || measurePath.measurePathType === idm_dataset_service_client_js_1.MeasurePathType.NUMBER) && columnMeasureBuilder.setShowOnRowsTotal(false);
            }
        });
        // Build report row categories with sorting order if it set on rows
        let isSortedByRowCategory = (this.sortData["orderType"] !== undefined && this.sortData["sortFieldType"] === list_report_field_1.ListReportFieldType.ROW_CATEGORY_FIELD);
        let rowCategoryBuilder = exportReportBuilder.addRowCategory(rowCategories[0]).setTotalType(idm_reporting_service_client_js_1.TotalType.AFTER);
        // isSortedByRowCategory && rowCategoryBuilder.setOrderType(this.sortData["orderType"]);
        for (let rowCategoryIndex = 1, rowCategoriesLength = rowCategories.length; rowCategoryIndex < rowCategoriesLength; rowCategoryIndex++) {
            isSortedByRowCategory && rowCategoryBuilder.setOrderType(this.sortData["orderType"]);
            rowCategoryBuilder = rowCategoryBuilder.addRowCategory(rowCategories[rowCategoryIndex]).setTotalType(idm_reporting_service_client_js_1.TotalType.BEFORE);
        }
        if (exportSettings !== undefined) {
            exportReportBuilder.setShowPageNumberOnFooter(exportSettings.isPageNumberIncluded);
            exportSettings.isHeaderIncluded && exportReportBuilder.setHeader(ListViewComponent_1.processListExportSettings(exportSettings.exportHeader, exportSettings.headerFontStyle));
            exportSettings.isFooterIncluded && exportReportBuilder.setFooter(ListViewComponent_1.processListExportSettings(exportSettings.exportFooter, exportSettings.footerFontStyle));
        }
        return exportReportBuilder.build();
    }
    /**
     * Constructs and return export data
     * @param exportPageOrientation
     * @param csvDelimiter
     * @private
     */
    getExportData(exportPageOrientation, csvDelimiter = idm_report_export_service_client_js_1.CSVDelimiter.COMMA) {
        const exportReport = this.buildExportedReport();
        exportReport.exportReportStylesDto = exportReport.exportReportStylesDto || new idm_report_export_service_client_js_1.ExportReportStylesDto();
        exportReport.exportReportStylesDto.exportPageOrientation = exportPageOrientation;
        exportReport.exportReportStylesDto.csvDelimiter = csvDelimiter;
        exportReport.exportReportStylesDto.title = new idm_report_export_service_client_js_1.MultilingualStyledTextDto(this.reportTitle, null);
        let exportReportFilter = this.listModel.getFilter();
        this.pageFilterTreeDto && (exportReportFilter = idm_reporting_service_client_js_1.FilterDtoBuilder.combineAnd(exportReportFilter, this.pageFilterTreeDto));
        const entityId = this.entity && this.entity.getInstanceId();
        (this.filters || entityId) && (exportReportFilter = this.updateFilters(this.filters, exportReportFilter, this.category, entityId, this.rootCategory));
        const reportOptions = this.buildReportOptions();
        return {
            exportReport,
            exportReportFilter,
            reportOptions
        };
    }
    /**
     * Method create report options, using the received properties and applying rows total getting property.
     * @returns {ReportOptions}
     */
    buildReportOptions() {
        let reportOptions = this.listModel.getReportOptions();
        return reportOptions.fetchTotalCount ? reportOptions : new idm_reporting_service_client_js_1.ReportOptions(reportOptions.showIndicatorDisaggregations, reportOptions.hideUnspecifiedRowHierarchy, true, reportOptions.outSidePathHolderIds, true);
    }
    static processListExportSettings(exportProperty, fontStyle = null) {
        return new idm_report_export_service_client_js_1.MultilingualStyledTextDto(exportProperty, ListViewComponent_1.convertFontStyleToBackendFormat(fontStyle));
    }
};
ListViewComponent.UNTITLED_MESSAGE_KEY = 'reporting.controls.list.untitled';
ListViewComponent.CATEGORIES_ICONS_PATH = 'categories/icons/';
ListViewComponent.LOAD_MORE_PAGING_SIZE = 100;
ListViewComponent.EXPAND_PAGING_SIZE = 50;
__decorate([
    core_1.Input(),
    __metadata("design:type", list_model_1.ListModel)
], ListViewComponent.prototype, "listModel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ListViewComponent.prototype, "id", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ListViewComponent.prototype, "dataSetId", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ListViewComponent.prototype, "state", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", idm_de_core_frontend_1.Entity)
], ListViewComponent.prototype, "entity", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ListViewComponent.prototype, "category", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ListViewComponent.prototype, "filters", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ListViewComponent.prototype, "isEditMode", void 0);
__decorate([
    core_1.ViewChild('rcListToolbarSection'),
    __metadata("design:type", core_1.ElementRef)
], ListViewComponent.prototype, "rcListToolbarSection", void 0);
__decorate([
    core_1.ViewChild('rcListToolbarTitle'),
    __metadata("design:type", core_1.ElementRef)
], ListViewComponent.prototype, "rcListToolbarTitle", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ListViewComponent.prototype, "title", null);
ListViewComponent = ListViewComponent_1 = __decorate([
    core_1.Component({
        
        selector: "list-view",
        styles: [require('./list-view.component.css')],
        template: require('./list-view.component.html')
    }),
    idm_dynamic_controls_metadata_1.ControlMetadata({
        cellCount: 12,
        groups: [
            {
                identity: "ReportingControls",
                name: "Reporting Controls",
                nameMessageKey: "reporting.controls.group.name",
            },
        ],
        settings: {
            main: list_builder_component_1.ListBuilderComponent,
        },
        template: `<list-view [id]="controlId"
                          [state]='%{state}'
                          [dataSetId]='%{datasetId}'
                          [title]='%{title}'
                          [category]='category'
                          [entity]='entity'
                          [filters]="filters"
                          [isEditMode]="isSettingsActive"></list-view>`,
        iconInfo: "list",
        name: "List",
        nameKey: "reporting.controls.list.widget.label",
        height: 400
    }),
    __param(14, core_1.Optional()),
    __param(15, core_1.Optional()),
    __metadata("design:paramtypes", [core_1.ElementRef,
        idm_session_data_provider_api_js_1.CurrentLanguageProvider,
        idm_dataset_service_client_js_1.CategoryPathService,
        idm_reporting_service_client_js_1.ReportingService,
        idm_dataset_service_client_js_1.PathService,
        idm_report_export_service_client_js_1.ReportExportService,
        idm_message_language_service_client_js_1.MessageService,
        idm_frontend_shared_1.FormResolverService,
        idm_dataset_service_client_js_1.PathFormsService,
        store_1.Store,
        idm_locale_service_client_js_1.LocaleService,
        idm_kb_service_client_js_1.KbService,
        idm_application_properties_service_client_js_1.StaticResourceUrlProvider,
        router_1.ActivatedRoute,
        idm_dynamic_controls_metadata_1.CommunicationService,
        page_filter_service_1.PageFilterService])
], ListViewComponent);
exports.ListViewComponent = ListViewComponent;
//# sourceMappingURL=list-view.component.js.map